import React from 'react';
import PropTypes from 'prop-types';
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {WmsStatsPeriod} from "api/wms/stats/stats";
import {blueColor, greyishBlue300, greyishBlue700} from "assets/jss/main";

PeriodSelector.propTypes = {
    period: PropTypes.oneOf(Object.values(WmsStatsPeriod)).isRequired,
    onChange: PropTypes.func.isRequired
};

function PeriodSelector({period, onChange}) {
    return (
        <ToggleButtonGroup
            exclusive
            size={"small"}
            value={period}
            onChange={(event, value) => value && onChange(value)}
            sx={{
                "& .MuiToggleButton-root": {
                    textTransform: "none",
                    padding: "4px 16px",
                    color: greyishBlue700,
                    borderColor: greyishBlue300
                },
                "& .MuiToggleButton-root.Mui-selected": {
                    color: blueColor,
                    fontWeight: 600
                }
            }}
        >
            <ToggleButton value={WmsStatsPeriod.TODAY}>
                <FormattedMessage id={"wms.admin_wms_stats.period.today"}/>
            </ToggleButton>
            <ToggleButton value={WmsStatsPeriod.WEEK}>
                <FormattedMessage id={"wms.admin_wms_stats.period.week"}/>
            </ToggleButton>
        </ToggleButtonGroup>
    );
}

export default PeriodSelector;
